// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import {
  getAuth,
  connectAuthEmulator,
  GoogleAuthProvider,
} from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDmPpNtAABcl9K5WyD840xkIoQa53se378",
  authDomain: "challengeapp-5a5f2.firebaseapp.com",
  projectId: "challengeapp-5a5f2",
  storageBucket: "challengeapp-5a5f2.appspot.com",
  messagingSenderId: "472655443463",
  appId: "1:472655443463:web:6c3418f6a3d9a2a5501ca2",
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const functions = getFunctions(app);
const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

// Fix emulator connection
const isLocalhost =
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1";

if (isLocalhost) {
  console.log("🔥 Using Firebase Emulators");
  try {
    connectFirestoreEmulator(db, "localhost", 8083);
    connectFunctionsEmulator(functions, "localhost", 5003);
    connectAuthEmulator(auth, "http://localhost:9099", {
      disableWarnings: true,
    });
  } catch (e) {
    console.error("Failed to connect to emulators:", e);
  }
}

export { db, functions, auth };
